import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h4 pb-2 mb-5 text-fprimary border-bottom border-danger d-flex align-items-center justify-content-between" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_ModalListPersons = _resolveComponent("ModalListPersons")!
  const _component_ModalRegister = _resolveComponent("ModalRegister")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_ctx.t('attendees')), 1),
      (_ctx.event?.register == 1)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: _ctx.openModalSelectPersons
          }, {
            default: _withCtx(() => [
              _createTextVNode("Registrar")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.listNominal,
      height: 500,
      border: "",
      "table-layout": "auto",
      "scrollbar-always-on": "",
      class: "fs-7",
      "header-cell-class-name": "text-black bg-light-info text-uppercase text-center",
      "highlight-current-row": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          label: "N°",
          width: "50",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "persona",
          label: "Participante",
          width: "280"
        }),
        _createVNode(_component_el_table_column, {
          prop: "function_name",
          label: "Categoría",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('state').toUpperCase(),
          align: "center",
          width: "110"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", {
              class: _normalizeClass(`badge badge-${scope.row.check_class}`)
            }, _toDisplayString(scope.row.check_name), 3)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "Registrado",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          label: "Opcion",
          width: "100",
          fixed: "right",
          align: "center"
        }, {
          default: _withCtx(({row}) => [
            (_ctx.event?.register == 1)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  effect: "dark",
                  content: _ctx.t('delete'),
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      class: "bi bi-trash fs-2 text-danger me-4 cursor-pointer",
                      onClick: ($event: any) => (_ctx.onDelete(row))
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 2
                }, 1032, ["content"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.loader]
    ]),
    _createVNode(_component_ModalListPersons, {
      event: _ctx.event,
      "type-register": 'ASI',
      sport: _ctx.activity,
      onGetSelectRow: _ctx.getSelectRow
    }, null, 8, ["event", "sport", "onGetSelectRow"]),
    _createVNode(_component_ModalRegister, {
      evento: _ctx.event,
      sport: _ctx.activity,
      setting: _ctx.listSetting,
      onOnResponse: _ctx.onResponse,
      action: _ctx.action,
      "type-register": 'ASI',
      "list-status": []
    }, null, 8, ["evento", "sport", "setting", "onOnResponse", "action"])
  ], 64))
}